import { createAction, props } from '@ngrx/store';
import { Redirect_search_routes } from '../../constants/urls.constants';
import { DefaultLookupResponseSearch } from '../../models/core-apis/default-lookup.interfaces';
import { PostDataSearchLocalStorage } from '../../models/postData-search-local-storage.interface';

export enum PostDataSearchActionTypes {
  updateSearchPostData = '[flight-shop book widget] update/create post data book widget',
  deleteSearchPostData = '[flight-shop book widget] delete post data book widget',
  updateEdocsSearchIndicator = '[flight-shop book widget] update edoc search indicator',
  readyToNavigateSearch = '[flight-shop book widget] ready to navigate on find flights action',
  loadDefaultLookupSearch = '[flight-shop book widget] load default lookup search',
  loadDefaultLookupSearchSuccess = '[flight-shop book widget] load default lookup search success',
  loadUpdateSearch = '[flight-shop book widget] Load  Update Search',
  loadUpdateSearchSuccess = '[flight-shop book widget] Load Success  Update Search',
  loadUpdateSearchFailure = '[flight-shop book widget] Load Failure  Update Search'
}

export const UpdateSearchPostData = createAction(
  PostDataSearchActionTypes.updateSearchPostData,
  props<{ cacheKeySuffix: string }>()
);
export const deleteSearchPostData = createAction(
  PostDataSearchActionTypes.deleteSearchPostData,
  props<{ cacheKeySuffix: string }>()
);

export const ReadyToNavigateSearch = createAction(
  PostDataSearchActionTypes.readyToNavigateSearch,
  props<{
    redirectToPage: Redirect_search_routes;
    cacheKeySuffix: string;
  }>()
);

export const UpdateEdocsSearchIndicator = createAction(
  PostDataSearchActionTypes.updateEdocsSearchIndicator,
  props<{ isEdocsApplied: boolean }>()
);
export const LoadDefaultLookupSearch = createAction(
  PostDataSearchActionTypes.loadDefaultLookupSearch
);

export const LoadDefaultLookupSearchSuccess = createAction(
  PostDataSearchActionTypes.loadDefaultLookupSearchSuccess,
  props<{ defaultLookupSearchResponse: DefaultLookupResponseSearch }>()
);

export const LoadUpdateSearchApi = createAction(
  PostDataSearchActionTypes.loadUpdateSearch,
  props<{
    postDataSearch: PostDataSearchLocalStorage;
    redirectToPage: Redirect_search_routes;
    cacheKeySuffix: string;
  }>()
);

export const LoadUpdateSearchApiSuccess = createAction(
  PostDataSearchActionTypes.loadUpdateSearchSuccess,
  props<{
    redirectToPage: Redirect_search_routes;
    cacheKeySuffix: string;
  }>()
);
export const LoadUpdateSearchApiFailure = createAction(
  PostDataSearchActionTypes.loadUpdateSearchFailure,
  props<{
    redirectToPage: Redirect_search_routes;
    cacheKeySuffix: string;
  }>()
);
